import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { BaseApiService } from '@smartera/core';

@Injectable({
	providedIn: 'root',
})
export class ElasticsearchDataCollectorIndexService extends BaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/elasticsearch-data-collector/indices`;
	}

	scheduleDataSync(indexId: string, obj) {
		return this._restClientService.put(`${this.apiUrl}/${indexId}/schedule-data-sync`, obj);
	}

	unscheduleDataSync(indexId: string) {
		return this._restClientService.delete(`${this.apiUrl}/${indexId}/unschedule-data-sync`);
	}
}
